import { Component, Input } from '@angular/core';
import { CustomProductCardEnt } from 'src/app/shared/interfaces/custom-product-card-ent';


@Component({
  selector: 'app-custom-list-product',
  templateUrl: './custom-list-product.component.html'
})
export class CustomListProductComponent {

  @Input() listProduct: CustomProductCardEnt[] = [];

  constructor() {}
}
